export interface ICacheState {}

let cacheState: ICacheState = {};

export default cacheState;